import { render, staticRenderFns } from "./quick-chat.vue?vue&type=template&id=c5dbb346&"
import script from "./quick-chat.vue?vue&type=script&lang=js&"
export * from "./quick-chat.vue?vue&type=script&lang=js&"
import style0 from "./quick-chat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports